var React = require('react');

function FacebookInline (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n            .cls-1 {\n            fill: #fff;\n            }\n        ")),React.createElement("path",{"id":"Icon_awesome-facebook-f","data-name":"Icon awesome-facebook-f","className":"cls-1","d":"M13.63,14.063l.694-4.524H9.983V6.6a2.262,2.262,0,0,1,2.551-2.444h1.974V.306A24.068,24.068,0,0,0,11,0C7.429,0,5.092,2.167,5.092,6.09V9.538H1.118v4.524H5.092V25H9.983V14.063Z","transform":"translate(-1.118)","key":1})]);
}

FacebookInline.defaultProps = {"width":"13.39","height":"25","viewBox":"0 0 13.39 25"};

module.exports = FacebookInline;

FacebookInline.default = FacebookInline;
